import React from "react";
import {
    RadioGroup,
    Grid,
    TextField,
    Button,
    withStyles,
    Radio,
    MenuItem,
    Checkbox,
    InputLabel,
    Select,
    Input
} from "material-ui";

import {
    FormControl,
    FormHelperText,
    FormControlLabel,
    FormLabel
} from "material-ui/Form";
import Typography from "material-ui/Typography";

import styles from "./styles";
import { withRouter } from "react-router-dom";
import { validateFormData } from "../../../../common/formtool";
import { ToInt, ToReal, ToDuration } from "../../../../common/datatypetool";
import { feetToMetersDecimal, metersToFeetDecimal } from "../../../../common/utils";
import { QualificationEnum }  from './qualificationenums'

class Qualification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      qualifySpeed: [],
      cableType: [],
      displayPref: [],
      lengthOnly: false,
      shieldTest: false,
      xoverAllowed: false,
      nvp: 69,
      errors: {},
      qualificationInitialised: false,
      allowedCableTypes: []
    };
  }

  translateElements = (elements) => {
    const { translate } = this.props;
    if (elements !== undefined) {
      elements.forEach(e => {
        e.value = translate(e.value);
      });
    }
    return elements;
  };

  mapEnumValue = (key, type) => {
    switch (type.toLowerCase()) {
      case "qualifyspeed": {
        return QualificationEnum.QualifySpeed.filter(
          enumType => enumType.key === parseInt(key)
        );
      }
      case "cabletype": {
        return QualificationEnum.CableType.filter(
          enumType => enumType.key === parseInt(key)
        );
      }
      case "displaypref": {
        return QualificationEnum.DispPref.filter(
          enumType => enumType.key === parseInt(key)
        );
      }
    }
    return [];
  };

  getNVPForCable = cableid => {
    let cabletype = this.mapEnumValue(cableid, "cabletype");
    if (cabletype == null || cabletype.length <= 0) {
      return 69;
    } 
    return cabletype[0].nvp;
  }

  getAllowedCableTypes = speedid => {
    return speedid === 0 ? QualificationEnum.CableType :
    speedid === 5 || speedid === 6 ? QualificationEnum.CableTypeMbps : [];
  }

  getCableTypeSelected = (speedid, cableid) => {
    let allowed = this.getAllowedCableTypes(speedid);
    let cabletype = this.mapEnumValue(cableid, "cabletype")
    if (allowed.length > 0) {
      cabletype = allowed.filter(
        enumType => enumType.key === parseInt(cableid)
      );
      if (cabletype == null || cabletype.length <= 0) {
        cabletype = [allowed[0]];
      }
    }
    else {
      cabletype = [QualificationEnum.CableType[0]];
    }
    return cabletype;
  }

  updateQualificationStateData = (qualification) => {
    this.setState({
        qualifySpeed: this.mapEnumValue(qualification.qualifyspeedid, "qualifyspeed"),
        displayPref: this.mapEnumValue(qualification.displayprefid, "displaypref"),
        cableType: this.getCableTypeSelected(qualification.qualifyspeedid, qualification.cableid),
        nvp: parseInt(qualification.nvp),
        shieldTest: qualification.shieldtest === true,
        xoverAllowed: qualification.xoverallowed === true,
        lengthOnly: qualification.lengthonly === true,
        qualificationInitialised: true,
        allowedCableTypes: this.getAllowedCableTypes(qualification.qualifyspeedid)
    });
  };

  onChange = e => {
    const {
      qualification,
      qualifySpeed,
      lengthOnly
    } = this.state;
    let validateErrors = this.state.errors;
    const { translate } = this.props;
    switch (e.target.name.toLowerCase()) {
        case "qualifyspeed":
          let enumVal = this.mapEnumValue(e.target.value, "qualifyspeed");
          let speedid =  enumVal.length > 0 ? parseInt(enumVal[0].key) : 1;
          let cableid = this.state.cableType && this.state.cableType.length > 0 ? this.state.cableType[0].key : 18;
          let cabletype = this.getCableTypeSelected(speedid, cableid);
          let lengthonly = speedid > 0 ? false : lengthOnly;
          this.setState({
            qualifySpeed: enumVal,
            allowedCableTypes: this.getAllowedCableTypes(speedid),
            cableType: cabletype,
            nvp: cabletype && cabletype.length > 0 ? cabletype[0].nvp : 69,
            lengthOnly: lengthonly
          });
          break;
        case "cabletype":
          this.setState({
            cableType: this.mapEnumValue(e.target.value, "cabletype"),
            nvp: this.getNVPForCable(parseInt(e.target.value))
          });
          break;
        case "displaypref":
          this.setState({
            displayPref: this.mapEnumValue(e.target.value, "displaypref")
          });
          break;
        case "nvp":
          delete validateErrors[e.target.name];
          this.setState({
            nvp: ToInt(e.target.value)
          });
          break;
        case "lengthonly":
          this.setState({
            lengthOnly: e.target.checked
          });
          break;
        case "shieldtest":
          this.setState({
            shieldTest: e.target.checked
          });
          break;
        case "xoverallowed":
          this.setState({
            xoverAllowed: e.target.checked
          });
          break;
        default:
          return;
    }
    setTimeout(() => {
      this.onQualificationSave();
    }, 100);
  };

  onQualificationSave = () => {
    const {
      qualifySpeed,
      cableType,
      displayPref,
      lengthOnly,
      shieldTest,
      xoverAllowed,
      nvp
    } = this.state;
    const { translate, isTestEdit } = this.props;

    let validationObj = {
      nvp: {
        required: translate("formfield_error_general_required"),
        range: {
          minValue: 50,
          maxValue: 99,
          message: translate("test_nvp_out_of_range_desc", { min: 50, max: 99 })
        }
      },
    };

    let errors = validateFormData(
      { nvp },
      validationObj
    );

    const missingFieldName = Object.keys(errors)[0];
    if (missingFieldName) {
      const textField = document.getElementsByName(missingFieldName)[0];
      textField && textField.focus();
    }
    if (Object.keys(errors).length) {
      this.setState({ errors: errors });
      this.props.handleErrors(errors);
    } else {
      const payload = {
        qualifyspeedid: parseInt(qualifySpeed[0].key),
        cableid: parseInt(cableType[0].key),
        displayprefid: parseInt(displayPref[0].key),
        shieldtest: shieldTest,
        xoverallowed: xoverAllowed,
        lengthonly: lengthOnly,
        nvp: nvp ? parseInt(nvp) : 69
      };
      if (isTestEdit) {
        this.props.updateQualification(this.props.selectedTest, payload);
      }
      this.setState({
        errors: {}
      });
      this.props.handleErrors(errors);
    }
  };

  renderTranslatedValue = (selectedValue, translate) => {
    return selectedValue && selectedValue.length && translate(selectedValue[0].value);
  };

  renderValue = (selectedValue) => {
    return selectedValue && selectedValue.length && selectedValue[0].value;
  };


  render() {
    const {
      translate,
      classes,
      languages,
      selectedTest,
      isTestEdit,
      qualification
    } = this.props;
    const {
      nvp,
      qualifySpeed,
      cableType,
      displayPref,
      lengthOnly,
      shieldTest,
      xoverAllowed,
      allowedCableTypes,
      qualificationInitialised,
      errors
    } = this.state;

    let wiremapOnly = allowedCableTypes && (allowedCableTypes.length > 0);
  
    if (!qualificationInitialised) {
      this.updateQualificationStateData(qualification);
      setTimeout(() => {
          this.onQualificationSave();
      }, 100);
    }

    return (
      <div className={classes.summary}>
      {/* LINK QUALIFICATION */}
      <FormControl
        className={classes.textField}
        margin="normal"
      >
        <InputLabel id="qualifyspeed">{translate("link_qualification")}</InputLabel>
        <Select
          labelId="qualifyspeed"
          name="qualifyspeed"
          renderValue={() => qualifySpeed && qualifySpeed.length && qualifySpeed[0].key > 0 ?
            this.renderValue(qualifySpeed) : this.renderTranslatedValue(qualifySpeed, translate)}
          onChange={this.onChange}
          input={
            <Input value={() => qualifySpeed && qualifySpeed.length && qualifySpeed[0].key > 0 ?
              this.renderValue(qualifySpeed) : this.renderTranslatedValue(qualifySpeed, translate)} />
          }
          fullWidth
        >
        {QualificationEnum.QualifySpeed.map(enumType => {
            return (
                <MenuItem key={enumType.value} value={enumType.key}>
                    {enumType.key > 0 ? enumType.value : translate(enumType.value)}
                </MenuItem>
            );
        })}
        </Select>
      </FormControl>

      <Grid container>
      <Grid item xs={6}>
      {/* CABLE TYPE */}
      <FormControl
        className={classes.textField}
        margin="normal"
        disabled={!wiremapOnly}
      >
        <InputLabel id="cabletype">{translate("general_sub_test_wiremap_cable_type_label")}</InputLabel>
        <Select
          labelId="cabletype"
          name="cabletype"
          renderValue={() => this.renderTranslatedValue(cableType, translate)}
          onChange={this.onChange}
          input={
            <Input value={() => this.renderTranslatedValue(cableType, translate)} />
          }
          fullWidth
        >
        {allowedCableTypes.map(enumType => {
            return (
                <MenuItem key={enumType.value} value={enumType.key}>
                    {translate(enumType.value)}
                </MenuItem>
            );
        })}
        </Select>
      </FormControl>
      </Grid>
      <Grid item xs={6}>
      {/* LENGTH ONLY */}
      <FormControlLabel
        control={
          <Checkbox
            className={classes.checkbox}
            name="lengthonly"
            checked={lengthOnly}
            onChange={this.onChange}
            value={lengthOnly}
            color="primary"
            disabled={!wiremapOnly}
          />
        }
        label={
          <Typography className={classes.checkboxLabel} color={!wiremapOnly ? 'secondary' : 'inherit'}>
            {translate("length_only")}
          </Typography>
        }
      />
      </Grid>
      </Grid>

      <Grid container>
      <Grid item xs={6}>

      {/* NVP */}
      <FormControl
        label={
          <Typography className={classes.textField}>
            {translate("test_nvp")}
          </Typography>
        }>
        <TextField
          className={classes.textField}
          fullWidth
          error={errors.nvp ? true : false}
          name="nvp"
          label={translate("test_nvp")}
          margin="normal"
          value={nvp}
          onChange={this.onChange}
          helperText={
            errors.nvp
              ? errors.nvp
              : ""
          }
        />
      </FormControl>
      </Grid>
      <Grid item xs={6}>
      {/* SHIELD TEST */}
      <FormControlLabel
        control={
          <Checkbox
            className={classes.checkbox}
            name="shieldtest"
            checked={shieldTest}
            onChange={this.onChange}
            value={shieldTest}
            color="primary"
          />
        }
        label={
          <Typography className={classes.checkboxLabel}>
            {translate("shield_test")}
          </Typography>
        }
      />
      </Grid>
      <Grid item xs={6}>
      {/* DISPLAY PREF */}
      <FormControl
        className={classes.displayPref}
        margin="normal"
      >
        <InputLabel id="displaypref">{translate("general_sub_test_wiremap_disp_pref_label")}</InputLabel>
        <Select
          labelId="displaypref"
          name="displaypref"
          renderValue={() => this.renderValue(displayPref)}
          onChange={this.onChange}
          input={
            <Input value={() => this.renderValue(displayPref)} />
          }
          fullWidth
        >
        {QualificationEnum.DispPref.map(enumType => {
            return (
                <MenuItem key={enumType.value} value={enumType.key}>
                    {enumType.value === "Standard" ? translate("cablestandardname") : enumType.value}
                </MenuItem>
            );
        })}
        </Select>
      </FormControl>
      </Grid>      
      <Grid item xs={6}>

      {/* CROSSOVER ALLOWED */}
      <FormControlLabel
        control={
          <Checkbox
            className={classes.checkbox}
            name="xoverallowed"
            checked={xoverAllowed}
            onChange={this.onChange}
            value={xoverAllowed}
            color="primary"
          />
        }
        label={
          <Typography className={classes.checkboxLabel}>
            {translate("general_sub_test_wiremap_cross_over_label")}
          </Typography>
        }
      />
      </Grid>
      </Grid>
      </div>
  );
  }

  // component life cycles 
  componentWillMount() {
  }

  componentWillReceiveProps(nextProps) {
    const { qualificationInitialised } = this.state
    const { qualification, isTestEdit } = nextProps;
    this.setState( { qualification : nextProps.qualification });
    if (isTestEdit) {
      if (qualification && this.props.qualification != qualification) {
        this.updateQualificationStateData(qualification);
      }
    }
  }


  componentDidMount() {
    window.scrollTo(0, 0)
  }
}

export default withRouter(withStyles(styles)(Qualification));
